import React from "react";
import { EmailFormTemplate } from "./EmailFormTemplate";
import { RedirectToMortgageComparison } from "./RedirectToMortgageComparison";
import { useFormContext } from "../context/FormContext";
import { submitPurchaseData } from "../api/publicApiCrmContactClient";
import { IMarketingConsents } from "../types";

export const EmailToMortgageComparison = () => {
  const { formData } = useFormContext();

  const validSubmitHandler = async (email: string, consents: IMarketingConsents) => {
    await submitPurchaseData("", email, consents, formData);
  };

  return (
    <EmailFormTemplate
      ComponentToRenderOnSubmission={RedirectToMortgageComparison}
      onValidSubmit={validSubmitHandler}
    />
  );
};
